import { JobPost } from "@/pages/_layouts/jobs/types";
import SectionHeading from "@/components/SectionHeading";
import QuestionsDetailsReadOnly from "@/components/Forms/JobPostForm/components/QuestionsDetailsReadOnly";

interface JobApplicationInfoProps {
  jobPost: JobPost;
}

export function JobApplicationInfo({ jobPost }: JobApplicationInfoProps) {
  const applicationFormQuestions = jobPost.applicationForm?.questions;

  if (!applicationFormQuestions || applicationFormQuestions.length === 0) return null;

  return (
    <div data-testid="job-application-info">
      <SectionHeading
        heading="Job Application Additional Questions"
        body="The following questions are included after the required default questions in the job application form."
      />
      <QuestionsDetailsReadOnly questions={applicationFormQuestions} />
    </div>
  );
}
